// Author YuJiaBei
// Date 2021-01-05 08:33:12

class RepairConstructionUnit {
constructor({
        id = null,
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new RepairConstructionUnit();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.repair.repairConstructionUnit.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairConstructionUnit.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairConstructionUnit.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.repair.repairConstructionUnit.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairConstructionUnit.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {RepairConstructionUnit, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
